function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_125",
  "data-name": "Grupo 125",
  transform: "translate(-8.786)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-tv",
  "data-name": "Icon awesome-tv",
  d: "M25.393,0H2.059A2.059,2.059,0,0,0,0,2.059V15.785a2.059,2.059,0,0,0,2.059,2.059H12.572v1.373H5.709a1.373,1.373,0,0,0,0,2.745H22.181a1.373,1.373,0,0,0,0-2.745H15.317V17.844H25.393a2.059,2.059,0,0,0,2.059-2.059V2.059A2.059,2.059,0,0,0,25.393,0Zm-.686,15.1H2.745V2.745H24.707Z",
  transform: "translate(8.786 0)",
  fill: "#ee9236"
}));

var SvgTvIcon = function SvgTvIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.452,
    height: 21.962,
    viewBox: "0 0 27.452 21.962",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tv_icon.63bbca94.svg";
export { ForwardRef as ReactComponent };